import { render, staticRenderFns } from "./ParamForm.vue?vue&type=template&id=040ff8a4&"
import script from "./ParamForm.vue?vue&type=script&lang=js&"
export * from "./ParamForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports